<template>
    <div id="noticeDetail" class="main-container">
        <back-tool>
        </back-tool>
        <div class="content" :style="{height: `${windowHeight - 155}px`}">
            <div class="detail-container">
                <div class="detail__title">
                    logo
                </div>
                <div class="detail__value">
                    123
                </div>
                <div class="detail__title">
                    应用名称
                </div>
                <div class="detail__value">
                    123
                </div>
                <div class="detail__title">
                    所属平台
                </div>
                <div class="detail__value">
                    123
                </div>
                <div class="detail__title">
                    使用分类
                </div>
                <div class="detail__value">
                    123
                </div>
                <div class="detail__title">
                    应用编码
                </div>
                <div class="detail__value">
                    123
                </div>
                <div class="detail__title">
                    适用学校
                </div>
                <div class="detail__value">
                    123
                </div>
                <div class="detail__title">
                    操作手册
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';
    import moment from 'moment';
    import windowResize from '@/mixins/windowResize.js';
    import Uploader from '@/components/Uploader/WebUploader';

    export default {
        name: "noticeDetail",
        data() {
            return {
                id: this.$route.query.id,
            }
        },
        components: {Uploader, BackTool},
        mixins: [windowResize],
        created() {
        },
        methods: {
            jumpToPage(path, query = {}) {
                this.$router.push({
                    path,
                    query
                })
            },
        }
    }
</script>

<style lang="scss">
    @import "../../../../src/styles/mixin.scss";
    #noticeDetail {
        .content {
            background-color: #fff;
            padding-left: 102px;
            overflow-y: auto;
        }


        .breadcrumb-container {
            padding-left: 12px;
            background-color: #F9FBFF;
            border-bottom: 1px solid #DCE0E2;
        }

        .form-container {
            width: 752px;
            margin: 0 auto;
        }
        .detail-container {
            width: 752px;
            margin: 0 auto;
            .device-name {
                font-size: 20px;
            }
            .detail__title {
                margin: 22px 0 14px 0;
                border-left: 4px solid #409EFF;
                padding-left: 12px;
                height: 16px;
                line-height: 16px;
            }
            .detail__value {
                line-height: 38px;
                background-color: #F7FBFD;
                padding-left: 16px;
                color: #777;
                @include clearfix;
                .upload-file-item {
                    height: 72px;
                    width: 40px;
                    img {
                        margin: 16px 0;
                        width: 40px;
                        height: 40px;
                    }
                    .file-name {
                        display: none;
                    }
                }
            }
        }
        .screen-protect-image {
            width: 300px;
            margin-right: 20px;
            margin-bottom: 20px;
        }
        .version-select-container {
            @include middleIB;
            width: 200px;
        }
        .file_box_wrap {
            @include middleIB;
        }
        .file__file-name {
            @include middleIB;
        }
        .download-icon {
            margin-left: 10px;
            color: #bbb;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/moduleApp/moduleAppDetail.vue